import { useState, useEffect } from "react";
import api from "../../utils/api";
import "./styles.scss";
import { useNavigate } from "react-router-dom";

export default function ResetPassword() {
    const [token, setToken] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");

    const navigate = useNavigate();

    // Pegar token da URL
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = urlParams.get("token");
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
        } else {
            setError("Token não encontrado na URL");
        }
    }, []);

    const getPasswordStrength = (password) => {
        if (password.length === 0) return { text: "", color: "" };
        if (password.length < 6) return { text: "Fraca", color: "weak" };
        if (password.length < 10) return { text: "Média", color: "medium" };
        return { text: "Forte", color: "strong" };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess(false);

        // Validações
        if (newPassword.length < 6) {
            setError("A senha deve ter no mínimo 6 caracteres");
            setLoading(false);
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("As senhas não coincidem");
            setLoading(false);
            return;
        }

        try {
            const response = await api.post("/confirm-reset-password", {
                token,
                newPassword,
            });

            if (response.data.success) {
                setSuccess(true);
                setNewPassword("");
                setConfirmPassword("");

                // Redirecionar após 3 segundos
                setTimeout(() => {
                    navigate("/login")
                }, 3000);
            } else {
                setError(response.data.message || "Erro ao redefinir senha");
            }
        } catch (err) {
            setError("Erro ao conectar com o servidor");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const strength = getPasswordStrength(newPassword);

    return (
        <div id="reset-password">
            <div className="reset-password__container">
                <div className="reset-password__header">
                    <div className="reset-password__icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                        </svg>
                    </div>
                    <h2 className="reset-password__title">Redefinir Senha</h2>
                    <p className="reset-password__subtitle">
                        Digite sua nova senha abaixo
                    </p>
                </div>

                {success && (
                    <div className="reset-password__message reset-password__message--success">
                        <svg className="reset-password__message-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                            <p className="reset-password__message-title">Senha redefinida com sucesso!</p>
                            <p className="reset-password__message-text">
                                Redirecionando para o login...
                            </p>
                        </div>
                    </div>
                )}

                {error && (
                    <div className="reset-password__message reset-password__message--error">
                        <svg className="reset-password__message-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p>{error}</p>
                    </div>
                )}

                {!success && (
                    <form className="reset-password__form" onSubmit={handleSubmit}>
                        {/* Nova Senha */}
                        <div className="reset-password__field">
                            <label htmlFor="newPassword" className="reset-password__label">
                                Nova Senha
                            </label>
                            <div className="reset-password__input-wrapper">
                                <svg className="reset-password__input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                                <input
                                    id="newPassword"
                                    type={showPassword ? "text" : "password"}
                                    className="reset-password__input"
                                    placeholder="••••••••"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="reset-password__toggle-password"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? (
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                        </svg>
                                    ) : (
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                            {newPassword && (
                                <p className={`reset-password__strength reset-password__strength--${strength.color}`}>
                                    Força: {strength.text}
                                </p>
                            )}
                        </div>

                        {/* Confirmar Senha */}
                        <div className="reset-password__field">
                            <label htmlFor="confirmPassword" className="reset-password__label">
                                Confirmar Nova Senha
                            </label>
                            <div className="reset-password__input-wrapper">
                                <svg className="reset-password__input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                                <input
                                    id="confirmPassword"
                                    type={showConfirmPassword ? "text" : "password"}
                                    className="reset-password__input"
                                    placeholder="••••••••"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="reset-password__toggle-password"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                    {showConfirmPassword ? (
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                        </svg>
                                    ) : (
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                            {confirmPassword && newPassword !== confirmPassword && (
                                <p className="reset-password__error-text">
                                    As senhas não coincidem
                                </p>
                            )}
                        </div>

                        <button
                            type="submit"
                            className="reset-password__button"
                            disabled={loading || !token || !newPassword || !confirmPassword}
                        >
                            {loading ? "Redefinindo..." : "Redefinir Senha"}
                        </button>
                    </form>
                )}

                <div className="reset-password__footer">
                    <a href="/login" className="reset-password__back-link">
                        Voltar para o login
                    </a>
                </div>
            </div>

            <div className="reset-password__info">
                <p>🔒 Sua senha será criptografada com segurança</p>
            </div>
        </div>
    );
}